import { ProductOptionGroup } from '@congacommerce/ecommerce';
import { Expose, Type } from 'class-transformer';
import { EglProductOptionComponent } from './egl-product-option-component';

export class EglProductOptionGroup extends ProductOptionGroup {
    @Expose({ name: 'Apttus_Config2__Options__r' })
    @Type(() => EglProductOptionComponent)
    Options: Array<EglProductOptionComponent>;
}
